<div class="frame-in">
  @if (data) {
    <div >
      <div id="game-holder" class="quiz font-QuraneraV3"></div>
    </div>
  }
</div>
